import { jsx as _jsx } from "react/jsx-runtime";
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import { METRIC_DATA_DECORATOR_FANCY } from '@/metric/constants/dataDecorators';
import Diamond from '@/product/entity/Diamond';
export const FIELD_SHAPE_NORMALIZED_PERFORMANCE = {
    key: 'shapeNormalizedPerformance',
    label: 'Shape Norm. Perf.',
    fullLabel: 'Shape Normalized Performance',
    type: FieldType.Metric,
    spGroupId: SetupPresetGroupType.FireDiBOX,
    icon: 'metrics-normalized–cut-perf',
    getter(p) {
        if (p instanceof Diamond && p.integralNormMetric) {
            return p.integralNormMetric.hr;
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.integralNormMetric) {
            return p.integralNormMetric.val;
        }
        return null;
    },
    decorator: (_, p, { ratio, size, label, icon, metricClassName } = {}) => {
        if (p instanceof Diamond) {
            return (_jsx(OptMetricBar, { cutShapeId: p.cutShapeId, metric: p.integralNormMetric, metricDataDecorator: METRIC_DATA_DECORATOR_FANCY, ratio: ratio, type: "integral", children: (scale, abs) => (_jsx(MetricScaleContainer, { abs: abs, icon: icon, className: metricClassName, isMetricCalculated: Boolean(p.integralNormMetric), label: label, scale: scale, size: size })) }));
        }
        return null;
    },
    iteratee(p) {
        if (p instanceof Diamond && p.integralNormMetric) {
            return p.integralNormMetric.val;
        }
        return null;
    },
    contexts: ALL_CONTEXTS,
};
